<template>
  <b-button v-bind="$attrs" @click="$emit('click', $event)" :class="buttonClass">
    <slot name="icon">
      <i v-if="!!iconClass" class="fas" :class="iconClass"></i>
    </slot>
    <slot></slot>
  </b-button>
</template>

<script>
  export default {
    name: 'IconButton',

    props: {
      buttonClass: String,
      iconClass: String,
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../sass/config/variables';

  .btn {
    .svg-icon {
      height: $font-size-base;
    }

    &:hover .svg-icon {
      transition: $ease-effect;
    }
  }
</style>
